import firebase from "firebase/app";
import "firebase/auth";

import { buscarNegocioDe } from "@/services/negocio";

/**
 * Ficha del negocio del comercio autenticado.
 *
 * Espejo del módulo `cliente`: se carga una vez y se comparte entre las vistas
 * de "Mi empresa", que necesitan lo mismo (nombre para precargar formularios,
 * id para guardar, logo para mostrar).
 */

export const state = {
  ficha: null,
  correoCargado: null,
  cargando: false,
};

export const mutations = {
  SET_FICHA(state, { ficha, correo }) {
    state.ficha = ficha;
    state.correoCargado = correo;
  },
  SET_CARGANDO(state, valor) {
    state.cargando = valor;
  },
  LIMPIAR(state) {
    state.ficha = null;
    state.correoCargado = null;
  },
};

export const getters = {
  tieneNegocio: (state) => !!state.ficha,
  nombreNegocio: (state) => (state.ficha ? state.ficha.nombre || "" : ""),
};

export const actions = {
  async cargar({ commit, state }, { force = false } = {}) {
    const usuario = firebase.auth().currentUser;
    const correo = usuario && usuario.email ? usuario.email : null;

    if (!correo) {
      commit("LIMPIAR");
      return null;
    }
    if (!force && state.correoCargado === correo) return state.ficha;

    commit("SET_CARGANDO", true);
    try {
      const ficha = await buscarNegocioDe(correo);
      commit("SET_FICHA", { ficha, correo });
      return ficha;
    } catch (err) {
      console.warn("[negocio] no se pudo cargar la ficha:", err);
      return state.ficha;
    } finally {
      commit("SET_CARGANDO", false);
    }
  },

  limpiar({ commit }) {
    commit("LIMPIAR");
  },
};
